const SPLASH_SEEN_KEY = 'happily:splash-seen';

type SessionStore = Pick<Storage, 'getItem' | 'setItem'>;

function windowSessionStorage(): SessionStore | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/**
 * The full splash belongs to opening the app. sessionStorage lives as long as the window,
 * so it survives a reload (⌘R, a browser refresh, the web build's update restart) and is
 * empty again on the next launch. Returns true only for the first load of a window.
 */
export function claimFirstOpen(storage: SessionStore | null = windowSessionStorage()): boolean {
  try {
    if (storage?.getItem(SPLASH_SEEN_KEY)) return false;
    storage?.setItem(SPLASH_SEEN_KEY, '1');
  } catch {
    // Storage blocked: treat every load as an open, the behaviour before this existed.
  }
  return true;
}
